import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SessionModalService, SessionModalData } from '../session-modal.service';

@Component({
  selector: 'app-session-modal',
  templateUrl: './session-modal.component.html',
  styleUrls: ['./session-modal.component.scss']
})
export class SessionModalComponent implements OnInit {
  visible = false;
  data: SessionModalData | null = null;

  constructor(
    private sessionModal: SessionModalService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.sessionModal.data$.subscribe(d => {
      this.data = d;
      this.visible = !!d;
    });
  }

  get isReplaced(): boolean {
    return this.data?.code === 'SESSION_REPLACED';
  }

  get isInactive(): boolean {
    return this.data?.code === 'SESSION_INACTIVE';
  }

  goToLogin(): void {
    this.sessionModal.hide();
    this.router.navigate(['/login']);
  }
}